import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import CustomDropdown from "../../../components/reusable-ui/custom-dropdown";
import { isMobileDevice } from "../../../helpers/device-info-helper";
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import { getCashManagementSummary } from "../../../redux/slices";
import { useDispatch } from "react-redux";
import { isUserCashier } from "../../../helpers/isUserCashier";

const BranchCashInfo = () => {
  const [selectedBranchId, setSelectedBranchId] = useState<string>("");
  const [showBranchInfo, setShowBranchInfo] = useState<boolean>(false);
  const [totalAmount, setTotalAmount] = useState<any>(0);
  const [summaryInfoArr, setSummaryInfoArr] = useState<any>([]);

  const dispatch = useDispatch();
  const { businessBranchesDataMap, accountSummaryMap } = useSelector((state: RootState) => ({
    businessBranchesDataMap: state.businessReducer.businessBranchesDataMap,
    allChannelsDefDataMap: state.businessReducer.allChannelsDefDataMap,
    accountSummaryMap: state.accountingReducer.cashManagementSummary
  }));
  const currentBusinessId = useSelector((state: any) => state.businessReducer?.businessData?.branchId)

  const DROPDOWN_CONFIGS = {
    branchId: {
      optionsMap: businessBranchesDataMap,
      placeholder: "Select Branch",
      uniqueKey: "branchId",
      dropdownHeading: "Branches",
      searchPlaceholder: "Search a branch",
      parentClass: "w-6/12 max-w-[200px] sm:w-full",
      key: "branchId",
      getListItemText: (data: any) => data?.branchName,
      disable: isUserCashier()
    },
  };

  useEffect(() => {
    handleDefaultSelection();
  }, [businessBranchesDataMap]);

  useEffect(() => {
    if ( accountSummaryMap?.accountSummary?.length ){
      let total = accountSummaryMap?.accountSummary.reduce((acc: any, currVal: any) => {
        return acc + currVal.amount;
      }, 0);
      setTotalAmount(total);
      setSummaryInfoArr(accountSummaryMap.accountSummary);
    }else{
      setTotalAmount(0);
      setSummaryInfoArr([]);
    }
  }, [accountSummaryMap])

  const handleDefaultSelection = () => {
    if ( businessBranchesDataMap && Object.keys(businessBranchesDataMap).length && !selectedBranchId ){
      let firstObj:any = businessBranchesDataMap[currentBusinessId];
      if(firstObj.branchId){
        setSelectedBranchId(firstObj.branchId);
        fetchDataSummary({
          "branchId": firstObj.branchId
        })
      }
    }
  }

  const handleBranchSelection = (value: any, fieldToUpdate: string) => {
    console.log("handleBranchSelection: ", value, fieldToUpdate);
    setSelectedBranchId(value);
    fetchDataSummary({
      "branchId": value
    });
  };

  function fetchDataSummary(dataToPost: any) {
    const callback = (isSuccess: boolean) => {
      
    };
    // API call to fetch amount summary data
    dispatch(getCashManagementSummary({ dataToPost, callback }));
  }

  function renderCustomDropDown(dropdownConfig: {
    optionsMap: any;
    placeholder?: string;
    getListItemText?: any;
    parentClass?: string;
    dropdownHeading?: string;
    searchPlaceholder?: string;
    uniqueKey: any;
    key: string;
    disable: boolean
  }): any {
    return (
      <CustomDropdown
        optionsMap={dropdownConfig.optionsMap}
        isMultiSelect={false}
        placeholder={dropdownConfig.placeholder}
        getListItemText={dropdownConfig.getListItemText}
        parentClass={dropdownConfig.parentClass}
        dropdownHeading={dropdownConfig.dropdownHeading}
        searchPlaceholder={dropdownConfig.searchPlaceholder}
        onSubmit={(value: any) =>
          handleBranchSelection(value[0], dropdownConfig.key)
        }
        preSelectedValues={selectedBranchId}
        uniqueKey={dropdownConfig.uniqueKey}
        showErrorBox={false}
        isDisabled = {dropdownConfig.disable}
      ></CustomDropdown>
    );
  }

  const toggleBranchTable = () => {
    setShowBranchInfo(!showBranchInfo);
  }

  const headerPart = () => {
    return (
      <section className="branch-account-info flex justify-between items-center bg-[#397ef50d] px-24 sm:px-0 py-16 sm:bg-transparent">
        { showBranchInfo ? (
            <div className="branch-selection sm:w-8/12 w-6/12">
              {renderCustomDropDown(DROPDOWN_CONFIGS.branchId)}
            </div>
          ) : (
            <div className="text-18 sm:text-16 text-black font-inter font-bold">
              Account Summary
            </div>
          )
        }
        { isMobileDevice() &&
          <div className="">
            <ArrowDropDownCircleIcon sx={{color: "#678ABF", cursor: "pointer", transform: `${showBranchInfo ? "rotate(180deg)" : ""}`}} onClick={toggleBranchTable} />
          </div>
        }
        <div className="sm:hidden">
          { showBranchInfo ? (
            <div className="flex items-center gap-10">
              <p className="text-16 text-[#333333] font-inter font-normal">
                Account Balance:{" "}
              </p>
              <p className="text-16 text-[#333333] font-inter font-bold">
                ₹{totalAmount}
              </p>
              <ArrowDropDownCircleIcon sx={{color: "#678ABF", transform: "rotate(180deg)", cursor: "pointer"}} onClick={toggleBranchTable} />
            </div>
            ) : (
              <div className="flex items-center gap-10">
                <p className="text-13 text-[#445169] font-inter font-normal">
                  Click to expand
                </p>
                <ArrowDropDownCircleIcon sx={{color: "#678ABF", cursor: "pointer"}} onClick={toggleBranchTable} />
              </div>
            )
          }
        </div>
      </section>
    )
  }
  const tablePart = () => {
    return (
      <section className="payment-type-cnt grid grid-cols-5 gap-50 sm:pb-15 sm:grid-cols-none sm:gap-5 sm:px-10 border-t border-[#DDDDDD]">
        { isMobileDevice() &&
            <div className="flex items-center justify-between pt-20">
              <p className="text-16 text-[#333333] font-inter font-bold">
                Account Balance:{" "}
              </p>
              <p className="text-16 text-[#333333] font-inter font-bold">
                ₹{totalAmount}
              </p>
            </div>
        }
        {summaryInfoArr?.length > 0 && summaryInfoArr.map((paymentInfo: any, idx: number) => (
          <div
            className="pt-12 pb-22 sm:pb-0 border-r border-[#DDDDDD] break-words last:border-r-0 first:pl-36 sm:border-0 sm:first:pl-0 sm:flex sm:justify-between"
            key={idx}
          >
            <div className="text-13 sm:text-[14px] text-[#445169]">{paymentInfo.mode}</div>
            <div className="text-15 sm:text-[14px] text-[#445169] font-medium sm:font-normal">
              {paymentInfo.amount}
            </div>
          </div>
        ))}
      </section>
    )
  }
  return (
    <div
      className={`branch-cash-info-container border border-[#DDDDDD] rounded-[10px] sm:px-16 sm:bg-[#F2F8FF] sm:border-0 sm:rounded-[0px] sm:mt-[-7px]`}
    >
      {headerPart()}
      { showBranchInfo && tablePart()}
    </div>
  );
};

export default BranchCashInfo;
